"use client"

import { Accordion } from "@chakra-ui/react/accordion"
import React, { useEffect, useRef, useState } from "react"

import { Education } from "@/types/getAbout"

import AccordionEducationItem from "./AccordionEducationItem"

interface IExperienceCard {
  data: Education[]
  className: string
}

const AccordionEducation: React.FC<IExperienceCard> = ({ className, data }) => {
  const [value, setValue] = useState([""])
  const scrollPosRef = useRef(0)

  useEffect(() => {
    // Restore scroll position after accordion animation
    if (scrollPosRef.current !== 0) {
      window.scrollTo(0, scrollPosRef.current)
      scrollPosRef.current = 0
    }
  }, [value])

  const handleValueChange = (details: { value: string[] }) => {
    // Save current scroll position
    scrollPosRef.current = window.scrollY
    setValue(details.value)
  }

  return (
    <Accordion.Root
      className={className}
      collapsible
      display={"flex"}
      flexDirection="column"
      gap={2}
      onValueChange={handleValueChange}
      value={value}
      variant={"plain"}
    >
      {undefined !== data &&
        data.map((education, index) => (
          <AccordionEducationItem
            education={education}
            index={index}
            key={education.id}
            totalItems={data.length}
          />
        ))}
    </Accordion.Root>
  )
}

export default AccordionEducation
